export const TEXT_POST = "post";
export const TEXT_PUT = "put";
export const TEXT_DELETE = "delete";
export const TEXT_UPLOADED = "uploaded";
export const TEXT_CANCELED = "canceled";
export const TEXT_CONFIRMED = "confirmed";
export const SALARY_COMPONENT = "Salary component ";
export const SALARY_STRUCTURE = "Salary Structure ";
export const SALARY_SLIP = "Salary slip ";

export const SALARY_STRUCTURE_ASSIGNMENT = "Salary Structure Assignment";
export const PAYROLL_ENTRY = "Payroll entry";
export const EMPLOYEE_BENEFIT_CLAIM = "Employee Benefit Claim";

export const EMPLOYEE_GROUP = "Employee Group ";
export const ATTENDANCE = "Attendance";
export const ATTENDANCE_REQUEST = "Attendance Request";
export const COMPANY = "Company";
export const BRANCH = "Branch";
export const JOB_OPENING = "Job Opening";
export const PAYROLL_PERIOD = "Payroll period";
export const EMPLOYEE_OTHER_INCOME = "Employee Other Income";
export const EMPLOYEE_SKILL_MAP = "Employee Skill Map";
export const EMPLOYEE_PROMOTION = "Employee Promotion";
export const JOB_APPLICANT_SOURCE = "Job Applicant Source";
export const JOB_APPLICANT = "Job Applicant";
export const TERM_AND_CONDITION = "Term And Condition";
export const JOB_OFFER = "Job Offer";
export const EMPLOYEE_GRADE = "Employee Grade";
export const EMPLOYEE = "Employee";
export const EMPLOYEE_ONBOARDING_TEMPLATE = "Employee Onboarding Template";
export const EMPLOYEE_SEPARATION_TEMPLATE = "Employee Separation Template";
export const EMPLOYEE_TAX_EXEMPTION_CATEGORY =
  "Employee Tax Exemption Category";
export const EMPLOYEE_TAX_EXEMPTION_SUB_CATEGORY =
  "Employee Tax Exemption Sub Category";

export const RETENTION_BONUS = "Retention Bonus";
export const EMPLOYEE_ONBOARDING = "Employee Onboarding";
export const EMPLOYEE_SEPARATION = "Employee Separation";
export const EMPLOYEE_GRIEVANCE = "Employee Grievance";
export const GRIEVANCE_TYPE = "Grievance Type";
export const EMPLOYEE_TRANSFER = "Employee Transfer";
export const PROJECT_TYPE = "Project Type";
export const ACTIVITY_TYPE = "Activity Type";
export const ACTIVITY_COST = "Activity Cost";

export const PROJECT = "Project ";
export const SHIFT_TYPE = "Shift Type";
export const SHIFT_REQUEST = "Shift Request";
export const SHIFT_ASSIGNMENT = "Shift Assignment";
export const POST = "Post";
export const MATERIAL_REQUEST = "Material Request";

export const ITEM = "item";
export const ITEM_GROUP = "Item Group";
export const PROMOTION = "Promotion";
export const VOUCHER = "Voucher";
export const TAG = "Tag";
export const BRAND = "Brand";
export const WAREHOUSE = "Warehouse";
export const ITEMATTRIBUTE = "ItemAttribute";
export const PRICELIST = "PriceList";
export const HR_SETTING = "Hr Setting";
export const DAILY_WORK = "Daily Work Summary Group";
export const TIMESHEET = "Timesheet";
export const CONTRACT = "Contract";
export const APPRAISAL_TEMPLATE = "Appraisal Template";
export const ENERGY_POINT_RULE = "Energy Point Rule";
export const APPRAISAL = "Appraisal";
export const DRIVER = "Driver";
export const VEHICLE = "Vehicle";
export const VEHICLE_LOG = "Vehicle log";
export const SUPPLIER_GROUP = "Supplier Group";
export const SUPPLIER = "Supplier";
export const LOAN_TYPE = "Loan Type";
export const LOAN_APPLICATION = "Loan Application";
export const LOAN = "Loan";
export const LOAN_DISBURSEMENT = "Loan Disbursement";
export const ACCOUNT = "Account";
export const LOAN_SECURITY_TYPE = "Loan Security Type";
export const LOAN_SECURITY = "Loan Security";
export const LOAN_SECURITY_PRICE = "Loan Security";
export const BANK = "Bank";
export const LOAN_SECURITY_PLEDGE = "Loan Security Pledge";
export const LOAN_SECURITY_UNPLEDGE = "Loan Security Unpledge";
export const BANK_ACCOUNT_TYPE = "Bank Account Type";
export const BANK_ACCOUNT_SUB_TYPE = "Bank Account Sub Type";
export const BANK_ACCOUNT = "Bank Account";

export const PROCESS_LOAN_INTEREST_ACCRUAL = "Process Loan Interest Accrual";
export const PROCESS_LOAN_SECURITY_SHORTFALL =
  "Process Loan Security Shortfall";
export const PAYMENT_TERM = "Payment Term";
export const FISCAL_YEAR = "Fiscal Year";
export const CATEGORY = "Category";
export const JOURNAL_ENTRY_TEMPLATE = "Journal Entry Template";
